import React from "react";
import { Button } from "reactstrap";
import { useIntl } from "react-intl";
import "./CampaignsFilterPopover.scss";

export type CampaignFilterDraft = {
  statusActive: boolean;
  statusPaused: boolean;
  statusRetired: boolean;
  platformMeta: boolean;
};

export const defaultCampaignFilterDraft = (): CampaignFilterDraft => ({
  statusActive: true,
  statusPaused: true,
  statusRetired: true,
  platformMeta: true,
});

type Props = {
  draft: CampaignFilterDraft;
  onDraftChange: (next: CampaignFilterDraft) => void;
  onApply: () => void;
  onClear: () => void;
};

export default function CampaignsFilterPopover({
  draft,
  onDraftChange,
  onApply,
  onClear,
}: Props) {
  const intl = useIntl();

  const toggle = (key: keyof CampaignFilterDraft) => {
    onDraftChange({ ...draft, [key]: !draft[key] });
  };

  return (
    <div
      className="fb-campaigns-filter-popover"
      role="dialog"
      aria-label={intl.formatMessage({
        id: "app.advertisements.filters.title",
      })}
    >
      <div className="fb-campaigns-filter-popover__actions">
        <Button
          type="button"
          color="light"
          outline
          className="fb-campaigns-filter-popover__btn-clear"
          onClick={onClear}
        >
          {intl.formatMessage({ id: "app.advertisements.filters.clear" })}
        </Button>
        <Button
          type="button"
          className="fb-campaigns-filter-popover__btn-apply"
          onClick={onApply}
        >
          {intl.formatMessage({ id: "app.advertisements.filters.apply" })}
        </Button>
      </div>

      <div className="fb-campaigns-filter-popover__section">
        <div className="fb-campaigns-filter-popover__section-title">
          {intl.formatMessage({ id: "app.advertisements.filters.status" })}
        </div>
        <label className="fb-campaigns-filter-popover__option">
          <span>
            {intl.formatMessage({ id: "app.advertisements.filters.statusActive" })}
          </span>
          <input
            type="checkbox"
            checked={draft.statusActive}
            onChange={() => toggle("statusActive")}
          />
        </label>
        <label className="fb-campaigns-filter-popover__option">
          <span>
            {intl.formatMessage({ id: "app.advertisements.filters.statusPaused" })}
          </span>
          <input
            type="checkbox"
            checked={draft.statusPaused}
            onChange={() => toggle("statusPaused")}
          />
        </label>
        <label className="fb-campaigns-filter-popover__option">
          <span>
            {intl.formatMessage({ id: "app.advertisements.filters.statusRetired" })}
          </span>
          <input
            type="checkbox"
            checked={draft.statusRetired}
            onChange={() => toggle("statusRetired")}
          />
        </label>
      </div>

      <div className="fb-campaigns-filter-popover__section">
        <div className="fb-campaigns-filter-popover__section-title">
          {intl.formatMessage({ id: "app.advertisements.filters.platform" })}
        </div>
        <label className="fb-campaigns-filter-popover__option fb-campaigns-filter-popover__option--meta">
          <span className="fb-campaigns-filter-popover__meta-label">
            <span className="fb-campaigns-filter-popover__meta-icon" aria-hidden>
              ∞
            </span>
            {intl.formatMessage({ id: "app.advertisements.filters.platformMeta" })}
          </span>
          <input
            type="checkbox"
            checked={draft.platformMeta}
            onChange={() => toggle("platformMeta")}
          />
        </label>
      </div>
    </div>
  );
}
